<template>
    <div class="client_details_ro">
        <v-toolbar dark class="primary">
            <v-btn icon @click.native="$emit('close')" dark>
                <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>Informacje o opiekunie</v-toolbar-title>
        </v-toolbar>
        <v-card outlined>
            <v-card-title>
                Podstawowe
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="Imię" disabled v-model="details.name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Nazwisko" disabled v-model="details.surname"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Telefon" disabled v-model="details.phone"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="PESEL" disabled v-model="details.pesel"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card outlined>
            <v-card-title>
                Dane adresowe
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field label="Ulica" disabled v-model="details.street"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Kod pocztowy" disabled v-model="details.postcode"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="Miasto" disabled v-model="details.city"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: "ClientDetailsReadOnly",
        props: ['details']
    }
</script>

<style scoped>

</style>